import { render, staticRenderFns } from "./Registers.vue?vue&type=template&id=bae13dc2&"
import script from "./Registers.vue?vue&type=script&lang=js&"
export * from "./Registers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports